import React from "react";

const UserContext = React.createContext<any | null>(null);

export default UserContext;
